import React from 'react';

import barcode from  '../../assets/barcode.png';
import'./index.css';

const ScanBarcodeBlock = (props) => {

  return (
    <div className="scan-barcode">
      <h3 className="scan-barcode__title">Scan Barcode to join job</h3>
      <div className="scan-barcode__body">
        <div className="scan-barcode__image-wrapper">
          <img src={barcode} className="scan-barcode__barcode" alt="barcode"/>
        </div>
        <p className="scan-barcode__description">Employee should scan the qr-code with his app to assigment</p>
      </div>

    </div>
  );
}

export default ScanBarcodeBlock;